<uilab-mat-tab-group
    dynamicHeight
    preserveContent="true"
    animationDuration="0ms"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="selectedIndexChange($event)"
    uilab-mat-stretch-tabs="false"
    uilab-mat-align-tabs="start"
>
    @for (page of pages; track page) {
        <uilab-mat-tab [label]="page.title">
            <div class="page-content">
                @if (isCodeExampleTab(page)) {
                    <avd-component-examples-page
                        [componentName]="componentName()"
                    ></avd-component-examples-page>
                } @else if (page.type == 'ui') {
                    <section>
                        <ngx-dynamic-hooks
                            [content]="setAbsoluteImagePaths(page.content)"
                            [options]="options"
                            [parsers]="components"
                        ></ngx-dynamic-hooks>
                        @if (page?.exampleUrl) {
                            <iframe
                                class="externalContent"
                                [src]="safeUrl(page.exampleUrl)"
                                title="External content preview"
                            ></iframe>
                        }
                    </section>
                } @else {
                    <ngx-dynamic-hooks
                        [content]="setAbsoluteImagePaths(page.content)"
                        [options]="options"
                        [parsers]="components"
                    ></ngx-dynamic-hooks>
                }
                @if (page.type == 'icon-gallery') {
                    <section appIcons></section>
                }
                @if (page.type == 'icon-products') {
                    <section appIconProducts></section>
                }
                @if (page.type == 'app-icon-gallery') {
                    <section appAppIcons></section>
                }
            </div>
        </uilab-mat-tab>
    }
</uilab-mat-tab-group>
